import { NavigateFunction, To } from 'react-router-dom';
import authService from '../features/auth/auth.service';

let navigator: NavigateFunction;

export const setNavigator = (navFn: NavigateFunction) => {
  navigator = navFn;
};

export const navigate = (to: To, options?: { replace?: boolean; state?: any }) => {
  if (!navigator) throw new Error('Navigator is not set');
  navigator(to, options);
};

export const logoutAndRedirect = async () => {
  await authService.logout();
  navigate('/login', { replace: true });
};
